import { hut } from "./Hut"

export default { hut }
